// extracted by mini-css-extract-plugin
export default {"title":"styles_title__wGXxk","barContainer":"styles_barContainer__-SJnZ","label":"styles_label__9apoN","bar":"styles_bar__xzhW+","percentage":"styles_percentage__v0rfl"};